export default function ToggleNav() {
    let navToggle = document.querySelector('.nav-toggle');

    if (navToggle) {
        navToggle.addEventListener('click', function () {
            let nav = document.getElementById('main-nav');
            nav.classList.toggle('hidden');
        });
    }
}

